// CAP-SPIKE-5 — is this the native shell, or a browser?
//
// ONE ANSWER, ONE PLACE. Routing, the login copy and the status bar all ask
// this question, and they must never disagree — a shell that routes like an
// app but renders web copy is worse than either.
//
// WHY Capacitor.isNativePlatform() AND NOT THE ALTERNATIVES:
//
//   NOT a user-agent sniff. The WebView's UA string is a Safari UA with no
//   reliable marker, and any marker we added could be spoofed by a browser or
//   dropped by an iOS update. It answers "what does this claim to be", which
//   is a different question.
//
//   NOT a build flag. A flag means TWO builds of the same bundle, and the
//   whole premise of this spike is that the shell loads the identical `dist`
//   the web serves. A flag would make the phone and the browser different
//   artefacts, so a bug found on one would not be provably present on the
//   other — which is exactly what the spike exists to rule out.
//
//   Capacitor.isNativePlatform() asks the runtime bridge whether it is really
//   there. It is true only when the native container injected the bridge, and
//   false in every browser including the dev server, so one bundle behaves
//   correctly in both.

import { Capacitor } from '@capacitor/core'

/** True inside the iOS or Android shell, false in any browser. */
export function isNativeShell(): boolean {
  return Capacitor.isNativePlatform()
}

/**
 * Routes that exist to SELL Ghost CRM rather than to run it.
 *
 * A merchant who has installed the app has already bought in; showing them
 * the sales page on launch reads as a website in a box. These never render in
 * the shell.
 *
 * NOT LISTED, ON PURPOSE: the public customer routes (/q, /i, /portal, /r,
 * /reschedule, /cancel), the legal pages, and every dashboard route. A quote
 * link a customer taps is a legitimate destination and must open; it just is
 * not where the app starts.
 */
export const MARKETING_ROUTES = ['/', '/affiliates', '/signup', '/learn', '/pricing'] as const
